/* eslint-disable */
import axios from 'axios';  
import store from '../store'
import { reject } from 'q';
// 通用 Module 
const state = {
    isPurchase: false, // 判断是否已经购买 
    serviceInfo: {
        serviceButlerId: '', // 选中管家服务的id
        serviceState: 1 // 高级服务的状态 [可有可无， 不确定，]
    }
}
const mutations = {
    IS_PURCHASE(state, isPurchase) {
        state.isPurchase = isPurchase
    },
    SET_SELECTINFO(state, serviceInfo) {
        state.serviceInfo = serviceInfo
    }
}
const getters = {}
const actions = {
    isPurchase({ commit }, data) {
        // 用户是否购买了高级管家服务
        commit('IS_PURCHASE', data)
    },
    isService (context, dataInfo) { // 判断是否已经选择了服务管家 和 选择服务管家 [同一个接口]
        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/ButlerCustomer/GetButlerCustomer?customerId=${dataInfo.customerId}&exhibitionId=${dataInfo.exhibitionId}`).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 